import React from "react";
import s from "./style.module.css";
import cn from "classnames";

const BalanceChart = ({
  male_coded_count,
  female_coded_count,
  mf_ratio_score,
}) => {
  return (
    <div className={s.wrap}>
      <div
        className={s.bar}
        style={{
          "--size": male_coded_count,
        }}
      >
        <div
          className={cn(s.masculine, {
            [s.isZero]: male_coded_count === 0,
            [s.otherIsZero]: female_coded_count === 0,
          })}
          style={{ "--size": male_coded_count }}
        />
        <div
          className={cn(s.feminine, {
            [s.isZero]: female_coded_count === 0,
            [s.otherIsZero]: male_coded_count === 0,
          })}
          style={{ "--size": female_coded_count }}
        />
      </div>

      <div className={s.key}>
        <span
          className={cn(s.text, {
            [s.isZero]: male_coded_count === 0,
          })}
        >
          {male_coded_count}
        </span>

        <span
          className={cn(s.text, {
            [s.isZero]: female_coded_count === 0,
          })}
        >
          {female_coded_count}
        </span>
      </div>
    </div>
  );
};

export default BalanceChart;
